import {API} from 'aws-amplify';

// @ts-ignore
export const read = async () => API.get('robinhoodEngAdminApi', '/subscriptions', {});
// @ts-ignore
export const create = async (subscription) => API.put('robinhoodEngAdminApi', '/subscriptions', {body: subscription});
// @ts-ignore
export const del = async (id) => API.del('robinhoodEngAdminApi', `/subscriptions/${id}`, {});
// @ts-ignore
export const update = async (subscription) =>
  API.post('robinhoodEngAdminApi', `/subscriptions/${subscription.id}`, {body: subscription});
